export function styleResetFunc() {
  let resizecheck;
    resizecheck = $('#responsibleCheck').width();
    if (resizecheck != '2') {
    	$('#changeJs').removeAttr('style');
			$('.selectBtn').removeClass('open');
    }
}